import { req, withParams } from 'vuelidate/lib/validators/common'

export default (gte) =>
  withParams({ type: 'greaterEqual', gte }, (value) => {
    return !req(value) || Number(value) >= Number(typeof gte === 'function' ? gte() : gte)
  })
